'use client';

import { useTranslations } from 'next-intl';
import React from 'react';

/**
 * The newsletter subscription form component.
 */
export default function Newsletter() {
  const t = useTranslations('footer.newsletter');
  return <form action="https://istitutoimage.us12.list-manage.com/subscribe/post?u=66ee8752f9d28f318a2bbb9e0&amp;id=2e41162c58&amp;f_id=004989e3f0" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" target="_self" className="mt-3 sm:flex sm:max-w-md" data-sentry-component="Newsletter" data-sentry-source-file="newsletter.tsx">
      <label htmlFor="mce-EMAIL" className="sr-only">
        {t('email_label')}
      </label>
      <input type="email" name="EMAIL" id="mce-EMAIL" autoComplete="email" required className="w-full min-w-0 appearance-none rounded-md border-0 bg-white px-3 py-1 text-base text-gray-800 ring-1 ring-inset ring-offblueish placeholder:text-gray-500 focus:ring-2 focus:ring-inset focus:ring-offblue sm:w-64 sm:text-xs sm:leading-6 xl:w-full" placeholder={t('placeholder')} />

      {/* Mailchimp bot protection */}

      <div style={{
      position: 'absolute',
      left: '-5000px'
    }} aria-hidden="true">
        <input type="text" name="b_66ee8752f9d28f318a2bbb9e0_2e41162c58" tabIndex={-1} defaultValue="" />
      </div>

      <div className="mt-4 sm:ml-4 sm:mt-0 sm:shrink-0">
        <button type="submit" name="subscribe" className="flex w-full items-center justify-center rounded-md bg-offblack px-4 py-2 text-xs uppercase text-gray-300 hover:bg-offblue focus-visible:outline focus-visible:outline-offset-2 focus-visible:outline-offblue hover:cursor-pointer">
          {t('button')}
        </button>
      </div>
    </form>;
}